/**
 * ModuleMD PatientPortal API
 * ModuleMD PatientPortal API service
 *
 * OpenAPI spec version: 1.0.0
 * Contact: emrsupport@modulemd.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs/Observable';
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { LabOrders, AddPatientPCIFormData } from '../model/models';
import { environment } from '../../environments/environment';

@Injectable()
export class getJotFormURLService {

    protected basePath = environment.appSetting.apiUrl+'JotForm';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }



    public GetJotFormURL(FormID: number, JotFormID: number, PatientID: number, isPatientPortal: boolean, IsEditableByPatient: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<any>>;
    public GetJotFormURL(FormID: number, JotFormID: number, PatientID: number, isPatientPortal: boolean, IsEditableByPatient: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<any>>>;
    public GetJotFormURL(FormID: number, JotFormID: number, PatientID: number, isPatientPortal: boolean, IsEditableByPatient: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<any>>>;
    public GetJotFormURL(FormID: number, JotFormID: number, PatientID: number, isPatientPortal: boolean, IsEditableByPatient: boolean, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (FormID !== undefined && FormID !== null) {
            queryParameters = queryParameters.set('FormID', <any>FormID);
        }
        if (JotFormID !== undefined && JotFormID !== null) {
            queryParameters = queryParameters.set('JotFormID', <any>JotFormID);
        }
        if (PatientID !== undefined && PatientID !== null) {
            queryParameters = queryParameters.set('PatientID', <any>PatientID);
        }
        if (isPatientPortal !== undefined && isPatientPortal !== null) {
            queryParameters = queryParameters.set('isPatientPortal', <any>isPatientPortal);
        }
        if (IsEditableByPatient !== undefined && IsEditableByPatient !== null) {
            queryParameters = queryParameters.set('IsEditableByPatient', <any>IsEditableByPatient);
        }

        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): HttpParams; };
        let useForm = false;
        let convertFormParamsToString = false;
       
        return this.httpClient.get<Array<any>>(`${this.basePath}/GetJotFormURL`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }



    
}
